// extracted by mini-css-extract-plugin
export default {"container":"g__container--fM8Tc","success":"g__success--J8m6d","adc-light-blue":"g__adc-light-blue--ty2gS","caution":"g__caution--yf8N0","gray":"g__gray--qBEJ4"};